import { Github, Linkedin, Twitter } from 'lucide-react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__grid">
          <div className="footer__brandCol">
            <a className="footer__brand" href="#top">
              REVTRONE
            </a>
            <p className="footer__desc">
              Empowering architects with artificial intelligence to build a better, more
              sustainable world.
            </p>

            <div className="footer__social" aria-label="Social links">
              <a className="footer__socialLink" href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <Twitter className="footer__socialIcon" aria-hidden="true" />
              </a>
              <a className="footer__socialLink" href="https://github.com" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                <Github className="footer__socialIcon" aria-hidden="true" />
              </a>
              <a className="footer__socialLink" href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <Linkedin className="footer__socialIcon" aria-hidden="true" />
              </a>
            </div>
          </div>

          <div className="footer__col">
            <h5 className="footer__heading">Product</h5>
            <ul className="footer__list">
              <li>
                <a className="footer__link" href="#features">
                  Features
                </a>
              </li>
              <li>
                <a className="footer__link" href="#video-section">
                  Showcase
                </a>
              </li>
              <li>
                <a className="footer__link" href="#pricing">
                  Pricing
                </a>
              </li>
              <li>
                <a className="footer__link" href="/dashboard">
                  Dashboard
                </a>
              </li>
            </ul>
          </div>

          <div className="footer__col">
            <h5 className="footer__heading">Resources</h5>
            <ul className="footer__list">
              <li>
                <a className="footer__link" href="#features">
                  Documentation
                </a>
              </li>
              <li>
                <a className="footer__link" href="#features">
                  API Reference
                </a>
              </li>
              <li>
                <a className="footer__link" href="https://discord.com" target="_blank" rel="noopener noreferrer">
                  Community
                </a>
              </li>
              <li>
                <a className="footer__link" href="#features">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          <div className="footer__col">
            <h5 className="footer__heading">Account</h5>
            <ul className="footer__list">
              <li>
                <a className="footer__link" href="/login">
                  Sign In
                </a>
              </li>
              <li>
                <a className="footer__link" href="/signup">
                  Sign Up
                </a>
              </li>
              <li>
                <a className="footer__link" href="/dashboard">
                  Dashboard
                </a>
              </li>
              <li>
                <a className="footer__link" href="mailto:revitroneapp@gmail.com">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          <div className="footer__col">
            <h5 className="footer__heading">Legal</h5>
            <ul className="footer__list">
              <li>
                <a className="footer__link" href="/terms">
                  Terms of Service
                </a>
              </li>
              <li>
                <a className="footer__link" href="/privacy">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a className="footer__link" href="/refund">
                  Refund Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <p className="footer__copyright">© 2026 Revitrone. All rights reserved.</p>
          <div className="footer__status" aria-label="All systems operational">
            <span className="footer__statusDot" aria-hidden="true" />
            <span className="footer__statusText">All systems operational</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

